import {memo} from 'react'

import PropTypes from 'prop-types'

import Label from '@s-ui/react-atom-label'
import MoleculeSelectOption from '@s-ui/react-molecule-dropdown-option'
import MoleculeSelect, {moleculeSelectDropdownListSizes} from '@s-ui/react-molecule-select'
import ChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown'

const FormSelect = ({
  disabled,
  id,
  label,
  onChange = () => {},
  options,
  hasErrors = false,
  placeholder,
  size = moleculeSelectDropdownListSizes.SMALL,
  value
}) => {
  const _handleOnChange = (ev, {value}) => {
    onChange(ev, {value})
  }
  const inputProps = {
    id,
    label,
    placeholder,
    value,
    size,
    disabled,
    ...(hasErrors && {errorState: hasErrors})
  }

  return (
    <div className="mt-FormSelect">
      {label && <Label text={label} />}
      <MoleculeSelect {...inputProps} onChange={_handleOnChange} iconArrowDown={<ChevronDown size="medium" />}>
        {options.map(({id, isDisabled, label}, index) => (
          <MoleculeSelectOption disabled={isDisabled} key={`${index}${id}`} value={id}>
            {label}
          </MoleculeSelectOption>
        ))}
      </MoleculeSelect>
    </div>
  )
}

FormSelect.displayName = 'FormSelect'

FormSelect.propTypes = {
  disabled: PropTypes.bool,
  field: PropTypes.string,
  fieldType: PropTypes.string,
  hasErrors: PropTypes.bool,
  id: PropTypes.string,
  initialSearch: PropTypes.object,
  label: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isDisabled: PropTypes.bool,
      label: PropTypes.string
    })
  ).isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(Object.values(moleculeSelectDropdownListSizes)),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array])
}

export default memo(FormSelect)
export {moleculeSelectDropdownListSizes as formSelectSizes}
